export const createBillingProcessSchema = (periods) => ({
  title: 'Start Billing Cycle',
  type: 'object',
  properties: {
    period: {
      type: 'string',
      title: 'Period',
      enum: periods.map(({ id }) => id),
      enumNames: periods.map(({ name }) => name),
      default: periods && periods.length > 0 ? periods[0].id : undefined,
    },
  },
});
